import { createFileRoute } from '@tanstack/react-router';
import { PeopleListRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';
import { validatePeopleListSearch } from './-people-list-search';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 */
function PeopleIndexRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/')({
  component: PeopleIndexRoute,
  validateSearch: validatePeopleListSearch,
});
